import { gql } from "graphql-request";

// The hazard a map marker names, for the read-only details panel. The same
// `hazard(id:)` field the apps' details sheet reads; any status comes back, so
// a hazard that has since been cleared or expired can be told apart from one
// that is still on the map. Null for an unknown or deleted id.
export const GetHazardById = gql`
  query GetHazardById($id: ID!) {
    hazard(id: $id) {
      id
      hazardType
      passability
      confirmationState
      status
      latitude
      longitude
      reportedAt
      lastConfirmedAt
      confirmationsCount
      confirmedBy {
        initials
        avatar {
          smUrl
        }
      }
      isMine
      photos {
        id
        position
        url
        thumbnailUrl
      }
    }
  }
`;
